import React, { memo } from 'react';
import { useTranslation } from 'react-i18next'

import { topCategories, ICategoryNavItem, toTourCategory } from '../../../store/global/tourCategories'
import { ITopToursCategory, AppStoreDispatchAction, EAppActionTypes, withAppStoreValue } from '../../../store';
import { INearByTour } from '../common';
import { TourPageMenuContent } from '../../tours-inner/components';

interface IPageMenuContentAppStoreProps {
    dispatch: AppStoreDispatchAction
    selectedTopCategory: ITopToursCategory
}

interface IPageMenuContentExtraProps {
    actualNearByTour: INearByTour
}

const PageMenuContentCore = memo(({ dispatch, selectedTopCategory, actualNearByTour } : IPageMenuContentExtraProps & IPageMenuContentAppStoreProps) => {
    const { t } = useTranslation()

    if (actualNearByTour) {
        return (
            <TourPageMenuContent
                tour={actualNearByTour.tour}
                selectedTopCategory={selectedTopCategory}
            />
        )
    }

    const handleItemClick = (item: ICategoryNavItem) => (e?: React.MouseEvent<HTMLElement, MouseEvent>) => {
        if (e) e.preventDefault();

        dispatch({ type: EAppActionTypes.SetFilter, filter: item.filter})
        dispatch({ type: EAppActionTypes.SetSelectedTopCategory, selectedTopCategory: toTourCategory(item)})
    }

    return (
        <div className="page-menu-content clearfix">
            <ul>
                {topCategories.map((item) =>
                    <li key={item.name}>
                        <button onClick={handleItemClick(item)} className={item.name === selectedTopCategory.name ? "active nav-item" : "nav-item"}>
                            <img src={item.icon} alt={t(item.name)} />
                            {t(item.name)}
                        </button>
                    </li>
                )}
            </ul>
        </div>
    )
})

export default withAppStoreValue<IPageMenuContentAppStoreProps, IPageMenuContentExtraProps>(PageMenuContentCore, ['dispatch', 'categories.selectedTopCategory'])